import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const catalogService = {
  getAllCatalog,
  getCatalog,
  getCatalogByItemCode,
  upsertCatalogByItemCode,
  createCatalog,
  updateCatalog,
  deleteCatalog,
  syncCatalog,
  getCatalogSyncStatus,
  getCatalogUoms,
  createCatalogUom,
  updateCatalogUom,
  deleteCatalogUom,
  getCanExchangeItems,
  setCanExchange,
  getShowingInSalesDocsItems,
  setIsShowingInSalesDocs,
  setIsActive,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.category) params.category = filter.category
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

export function getAllCatalog(filter) {
  return apiHelper(API_URL).get('/catalog', { params: buildParams(filter) })
}
export function getCatalog(uuid) {
  return apiHelper(API_URL).get(`/catalog/${uuid}`)
}
export function getCatalogByItemCode(itemCode) {
  return apiHelper(API_URL).get(`/catalog/by-item-code/${itemCode}`)
}
export function upsertCatalogByItemCode(itemCode, formData) {
  return apiHelper(API_URL).post(`/catalog/by-item-code/${itemCode}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
export function createCatalog(formData) {
  return apiHelper(API_URL).post('/catalog', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
export function updateCatalog(uuid, formData) {
  return apiHelper(API_URL).put(`/catalog/${uuid}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
export function deleteCatalog(uuid) {
  return apiHelper(API_URL).delete(`/catalog/${uuid}`)
}
export function syncCatalog() {
  return apiHelper(API_URL).post('/catalog/sync')
}
export function getCatalogSyncStatus() {
  return apiHelper(API_URL).get('/catalog/sync-status')
}
export function getCatalogUoms(itemCode) {
  return apiHelper(API_URL).get(`/catalog/${encodeURIComponent(itemCode)}/uoms`)
}
export function createCatalogUom(itemCode, data) {
  return apiHelper(API_URL).post(`/catalog/${encodeURIComponent(itemCode)}/uoms`, data)
}
export function updateCatalogUom(uuid, data) {
  return apiHelper(API_URL).put(`/catalog/uoms/${uuid}`, data)
}
export function deleteCatalogUom(uuid) {
  return apiHelper(API_URL).delete(`/catalog/uoms/${uuid}`)
}
export function getCanExchangeItems() {
  return apiHelper(API_URL).get('/catalog/can-exchange-items')
}
export function setCanExchange(itemCode, value) {
  return apiHelper(API_URL).patch(
    `/catalog/by-item-code/${itemCode}/can-exchange`,
    { can_exchange: value }
  )
}
export function getShowingInSalesDocsItems() {
  return apiHelper(API_URL).get('/catalog/showing-in-sales-docs-items')
}
export function setIsShowingInSalesDocs(itemCode, value) {
  return apiHelper(API_URL).patch(
    `/catalog/by-item-code/${itemCode}/showing-in-sales-docs`,
    { is_showing_in_sales_docs: value }
  )
}
export function setIsActive(itemCode, value) {
  return apiHelper(API_URL).patch(
    `/catalog/by-item-code/${itemCode}/is-active`,
    { is_active: value }
  )
}
